import React, { } from "react";
import { IconButton, Tooltip, TooltipProps } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import "../styles/Select.css"

type Props = {
  label?: React.ReactNode,
  description: JSX.Element | string,
  tooltipProps?: Partial<TooltipProps>
}

const AsyncMultiInfoLabel = ({ label, description, tooltipProps }: Props) => {
  if(!label && !description) return null;
  return (
    <div className="description">
      {label}
      {!!description && (
        <Tooltip
          {...tooltipProps}
          title={description}
          arrow={true}
        >
          <IconButton size="small">
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      )}
    </div>
  )
}

export default AsyncMultiInfoLabel;
